export interface DprStatusTrackerGridData extends DprStatusTrackerGridDataBase {
  [key: string]: any;
}

export interface DprStatusTrackerGridDataBase {
  id: number | string;
  rowId: number;
  row: string;
  groupId: number;
  cellColors: {
    [key: string]: number;
  };
}

export const DprStatusTrackerGridDataBaseProperties = [
  'id',
  'rowId',
  'row',
  'groupId',
  'cellColors',
];
